module.exports = __webpack_public_path__ + "static/langojango-swahili-language-phrasebook-c9e2e8f04dc1aaf2b5efc734afaa03b4.png";